<script>
  import FusionCharts from 'fusioncharts';
  import Charts from 'fusioncharts/fusioncharts.charts';
  import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
  import GammelTheme from 'fusioncharts/themes/fusioncharts.theme.gammel';
  import UmberTheme from 'fusioncharts/themes/fusioncharts.theme.umber';
  import OceanTheme from 'fusioncharts/themes/fusioncharts.theme.ocean';
  import ZuneTheme from 'fusioncharts/themes/fusioncharts.theme.zune';
  import SvelteFC, { fcRoot } from 'svelte-fusioncharts';
  import Moon from 'svelte-loading-spinners/dist/ts/Moon.svelte';

  export let chartData;
  export let caption;
  export let category;
  export let sNumberPrefix = '';
  export let numberPrefix = '';
  export let type;
  export let options;
  export let width = '100%';
  export let height = 400;
  export let loading = true;
  export let pYAxisName;
  export let sYAxisName;
  export let xAxisName= 'Hour';
  export let theme = 'fusion';
  export let subCaption = 'In the last 24/h'
  export let formatNumberScale = false

  function getTheme() {
    switch (theme) {
      case 'gammel':
        return GammelTheme;
      case 'ocean':
        return OceanTheme;
      case 'umber':
        return UmberTheme;
      case 'zune':
        return ZuneTheme;
      case 'fusion':
      default:
        return FusionTheme;
    }
  }
  // Always set FusionCharts as the first parameter
  fcRoot(FusionCharts, Charts, getTheme());
  const { series } = chartData;

  if (options && !loading) {
    if (options && options.length) {
      options.every((o) => {
        const { index, ...option } = o;
        series[index] = { ...series[index], ...option };
      });
    }
  }
  const dataSource = {
    chart: {
      caption,
      subCaption,
      xAxisName,
      pYAxisName,
      sYAxisName,
      sNumberPrefix,
      numberPrefix,
      formatNumberScale,
      sformatNumberScale:formatNumberScale,
      plotToolText: 'there were <b>$dataValue</b> <b>$seriesName</b> at $label',
      theme,
    },
    categories: [{ category }],
    dataset: series,
  };

  const chartConfigs = {
    type,
    width,
    height,
    dataFormat: 'json',
    dataSource,
  };
  </script>

<div>
  {#if loading}
    <div class="h-16 flex items-center justify-center">
      <Moon size={2} color="#FF3E00" unit="rem" duration="1s" />
    </div>
  {:else}
    <SvelteFC {...chartConfigs} />
  {/if}
</div>
